import React from 'react'
import useDimensions from '../../../hooks/use-dimensions'
import { Badge } from 'react-bootstrap'
import { find } from 'lodash'

const DimensionBadge = ({
    dimensionId: id,
    style = {}
}) => {
    const [ dimensions ] = useDimensions()
    const dimension = find(dimensions, { id })
    if (!dimension) {
        return null
    }
    return (
        <Badge
            pill
            style={{ backgroundColor: dimension.color, color: 'black', ...style }}
        >
            {dimension.name}
        </Badge>
    )
}

export default DimensionBadge
